import React  from "react";
import { StyledRow } from "../Table";

interface CustomTableRowProps {
  style?: React.CSSProperties;
  readonly children: React.ReactNode;
  onDoubleClick?(): void;
  hoverOptionComponent?: React.ReactNode;
}

const CustomTableRow: React.FC<CustomTableRowProps> = ({
  style,
  children,
  hoverOptionComponent,
  onDoubleClick,
}) => {


  return (
    <>
      <StyledRow
        style={style}
       className="table-row"
       onDoubleClick={onDoubleClick}
      > 
        {hoverOptionComponent}
        {children}
       
      </StyledRow>
    </>
  );
};

export default React.memo(CustomTableRow);
